const url = "https://telegram-tracking-back-stage.iteora.com/api/";
// const url = "https://telegram-tracking-back.iteora.com/api/";

export default url;
